export default {
  lang: "text",
  headingKey: "heading",
  questions: {},
  errors: {},
  modal: { visible: false, message: "" },
  canMoveForward: true,
  shouldFinishSurvey: false,
};
